const InstagramIcon = ({ width = 16, height = 16, color = "white" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.75 1H4.25C2.45507 1 1 2.45507 1 4.25V10.75C1 12.5449 2.45507 14 4.25 14H10.75C12.5449 14 14 12.5449 14 10.75V4.25C14 2.45507 12.5449 1 10.75 1Z"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1016 7.0907C10.1818 7.63166 10.0894 8.18414 9.83751 8.66956C9.58564 9.15497 9.18711 9.54861 8.69862 9.79448C8.21014 10.0404 7.65656 10.1259 7.11663 10.0391C6.5767 9.95217 6.07791 9.69725 5.69121 9.31055C5.30451 8.92385 5.04959 8.42506 4.96271 7.88513C4.87583 7.3452 4.96141 6.79163 5.20728 6.30314C5.45315 5.81465 5.84679 5.41613 6.33221 5.16425C6.81763 4.91238 7.37011 4.81998 7.91107 4.9002C8.46287 4.98202 8.97372 5.23915 9.36817 5.6336C9.76262 6.02804 10.0197 6.5389 10.1016 7.0907Z"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0742 3.92578H11.0807"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default InstagramIcon;
